module.exports = __webpack_public_path__ + "static/media/user.d2a406e8.svg";